import React from 'react';
import styles from './ListItem.module.css';
import { IconButton, Tooltip } from '@mui/material';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import ColorPalette from '../../../../../colorpalette/ColorPalette';

const ListItem = ({ id, date, title, onSelect }) => {

    const formatDate = (dateString) => {
        const [year, month, day] = dateString.split('-');
        return `${day}/${month}/${year}`;
    };

    const handleViewDetails = () => {
        onSelect(id);
    }

    return (
        <div className={styles.container}>
            <div className={styles.infos}>
                <span className={styles.icon}>
                    <PictureAsPdfOutlinedIcon sx={{ fontSize: 18 }} />
                </span>
                <div className={styles.texts}>
                    <span className={styles.title}>{title}</span>
                    <span className={styles.date}>{formatDate(date)}</span>
                </div>
            </div>
            <Tooltip title="Visualizar">
                <IconButton
                    size="small"
                    onClick={handleViewDetails}
                    sx={{
                        color: ColorPalette.blueMain,
                        border: `1px solid ${ColorPalette.border}`,
                        borderRadius: '8px',
                        '&:hover': { backgroundColor: ColorPalette.blueAlpha2, borderColor: ColorPalette.blueLight3 }
                    }}
                >
                    <VisibilityOutlinedIcon sx={{ fontSize: 18 }} />
                </IconButton>
            </Tooltip>
        </div>
    );
};

export default ListItem;
